import { render } from "./ScaleField.vue?vue&type=template&id=895b4134"
import script from "./ScaleField.vue?vue&type=script&lang=js"
export * from "./ScaleField.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSlider from 'quasar/src/components/slider/QSlider.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSlider});
